import React, { useEffect } from "react";

import { changeColors, cellData } from "./utils";
import GridTitle from "./headingSVGs/GridTitle";
import GridAddendum from "./headingSVGs/GridAddendum";
function CellGrid({ selectCell }) {
  useEffect(() => {
    const cells = document.querySelectorAll("svg");
    const intervals = Array.from(cells).map((cell) => {
      const interval = setInterval(() => {
        changeColors(cell);
      }, 450);
      return interval;
    });
    return () => {
      intervals.forEach((interval) => clearInterval(interval));
    };
  }, []);

  return (
    <div className="cell-select">
      <GridTitle />
      <div className="cell-grid">
        {Object.keys(cellData).map((key, i) => {
          return React.createElement(cellData[key].element, {
            key: `cell-${key}-${i}`,
            clickFunction: () => selectCell(key),
          });
        })}
      </div>
      <GridAddendum />
    </div>
  );
}

export default CellGrid;
